import { ZollAPIService } from '../../../services/zollApi.service'
import { zollBaseURL } from '../../../services/api.service'
import { ZipResponse } from '../store/zip.types'
import { APIError } from '../../../features/submitChart/store/submitChart.types'

const zipUrl = `${zollBaseURL}/api/CityStateLookup`

export class ZipService extends ZollAPIService {
  async doCityStateLookup(data: string | unknown): Promise<ZipResponse> {
    return this.postWithError(zipUrl, data)
  }

  static createErrorResponse(responseMessage: string): ZipResponse {
    const response: any = {
      success: false,
      failure: true,
      responseMessage,
    }

    return response
  }

  static printAPIError(error: APIError) {
    console.log('----------------------------------')
    console.log('START: APIError')
    console.log('----------------------------------')

    ZipService.printAPIErrorInner(error, 1)

    console.log('----------------------------------')
    console.log('END: APIError')
    console.log('----------------------------------')
  }

  private static printAPIErrorInner(error: APIError, errorNumber: number) {
    console.log('-----------------')
    console.log(`Error number: ${errorNumber}`)
    console.log('-----------------')
    console.log(`Error message: ${error.message}`)
    console.log(`Error stackTrace: ${error.stackTrace ? error.stackTrace : 'none'}`)

    if (!error.cause) {
      console.log(`Error cause: none`)
    } else {
      ZipService.printAPIErrorInner(error.cause, errorNumber + 1)
    }
  }
}
